<template>
  <div class="lang">
    <ul>
      <li :class="$i18n.locale == 'kg' ? 'active' : ''">
        <a
          :class="$i18n.locale == 'kg' ? 'active' : ''"
          @click="changeLangAction('kg')"
        >
          Кырг
        </a>
      </li>
      <li :class="$i18n.locale == 'ru' ? 'active' : ''">
        <a
          :class="$i18n.locale == 'ru' ? 'active' : ''"
          @click="changeLangAction('ru')"
        >
          Рус
        </a>
      </li>
      <li :class="$i18n.locale == 'en' ? 'active' : ''">
        <a
          :class="$i18n.locale == 'en' ? 'active' : ''"
          @click="changeLangAction('en')"
        >
          Eng
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['changeLang']),
    changeLangAction (lang) {
      this.$i18n.locale = lang
      document.querySelector('html').setAttribute('lang', lang)

      this.changeLang(lang)
      window.location.reload()
    }
  }
}
</script>
